<template>
  
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        text
      >
        <v-icon large left>mdi-account</v-icon>
        <span>{{ authUserName }}</span>
      </v-btn>
    </template>
    <v-list>
      <template v-for="menu in menus">
        <v-list-item 
          :key="menu.text"
          @click="menu.action"
        >
          <v-list-item-title>
            <v-btn text class="grey--text">
              <v-icon left>{{ menu.icon }}</v-icon>
              <span>{{ menu.text }}</span>
            </v-btn>
          </v-list-item-title>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'UserMenuBtn',
  props:{
    menus: Array,
    authUserName: String,
  },
  data: () => ({
  }),
}
</script>